import React, { useMemo, useState } from 'react'
import classnames from 'classnames'
import MaterialReactTable from 'material-react-table'
import { MRT_Localization_PT } from 'material-react-table/locales/pt'
import { Nav, NavItem, NavLink } from 'reactstrap'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import OikosSelect from '../../components/Template/Input/Select'
import CompactAddFiles from '../../components/Template/Files/CompactAddFiles'
import ErpIconCatalog from './ErpIconCatalog'
import ErpKanban from './ErpKanban'
import {
  Box,
  DemoAccordion,
  DemoBtn,
  DemoCheck,
  DemoChips,
  DemoInput,
  DemoSelect,
  DemoSwitch,
  DemoTabs,
  DemoTextarea,
  Field,
  Flash,
  useFlash,
} from './demoKit'

/** Demos L1 interativas — clique, digite, selecione. */

const MRT_ROWS = [
  { nome: 'Projeto Alpha', status: 'Ativo', setor: 'Meio físico' },
  { nome: 'Projeto Beta', status: 'Pendente', setor: 'Meio biótico' },
  { nome: 'Contrato 1042', status: 'Ativo', setor: 'Jurídico' },
  { nome: 'Contrato 1043', status: 'Encerrado', setor: 'Financeiro' },
  { nome: 'Produto SSA', status: 'Ativo', setor: 'Meio físico' },
  { nome: 'Produto Norte', status: 'Pendente', setor: 'Socioeconômico' },
]

/** Mesmos props das listagens MRT de Produtos e Contratos. */
function OikosListingTable() {
  const columns = useMemo(
    () => [
      { accessorKey: 'nome', header: 'Nome' },
      { accessorKey: 'status', header: 'Status' },
      { accessorKey: 'setor', header: 'Setor' },
    ],
    [],
  )
  const data = useMemo(() => MRT_ROWS, [])
  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRT_Localization_PT}
      initialState={{
        density: 'compact',
        expanded: {},
        pagination: { pageIndex: 0, pageSize: 5 },
        sorting: [{ id: 'nome', desc: false }],
      }}
      enableGlobalFilter
      enableFilters
      enablePagination
      enableColumnFilters
      enableDensityToggle={false}
      positionPagination="bottom"
      muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
      muiTopToolbarProps={{
        sx: {
          '.MuiBox-root': { marginTop: '10px', height: '20px', display: 'flex', alignItems: 'center' },
          '.MuiSvgIcon-root': { width: '12px' },
          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: '30px !important', height: '30px !important' },
          '.MuiTablePagination-root': { minHeight: '30px !important', height: '30px !important', marginTop: '2.3rem' },
        },
      }}
      muiTableBodyCellProps={{ sx: { fontSize: '13px', whiteSpace: 'normal', overflowWrap: 'break-word' } }}
      muiTablePaginationProps={{
        sx: { '.MuiTablePagination-displayedRows': { fontSize: '12px' }, fontSize: '12px' },
        labelRowsPerPage: <span style={{ fontSize: '12px' }}>Linhas por página</span>,
        rowsPerPageOptions: [5, 10, 25],
      }}
      muiTableHeadCellProps={{
        sx: {
          fontSize: '12px',
          fontWeight: 'normal',
          padding: '8px',
        },
      }}
    />
  )
}

function OikosTabs({ tabs, active, onChange, children }) {
  return (
    <div>
      <Nav tabs className="nav-tabs-custom">
        {tabs.map((t) => (
          <NavItem key={t.id}>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({ active: active === t.id })}
              onClick={() => onChange(t.id)}
            >
              {t.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <div className="p-3">{children}</div>
    </div>
  )
}

const MONEY_BLOCKS = {
  num: {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: false,
    normalizeZeros: false,
    radix: ',',
    min: 0,
    max: 1000000000,
  },
}

const STATUS_OPTS = [
  { value: 'aberto', label: 'Aberto' },
  { value: 'analise', label: 'Em análise' },
  { value: 'fechado', label: 'Fechado' },
]

const MOCKS = {
  kanbanA: () => <ErpKanban />,
  btnConfirmA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="primary" onClick={() => flash('Confirmado ✓')}>
          Confirmar
        </DemoBtn>
        <DemoBtn variant="primary" disabled>
          Confirmar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnConfirmB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="dark" onClick={() => flash('Salvo ✓')}>
          Salvar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnConfirmC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="primary" onClick={() => flash('Alterações salvas')}>
          ✓ Salvar alterações
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  btnCancelA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
          Cancelar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnCancelB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="ghost" onClick={() => flash('Cancelado', 'warn')}>
          Cancelar
        </DemoBtn>
        <DemoBtn variant="ghost" onClick={() => flash('Voltando…', 'warn')}>
          Voltar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnCancelC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="muted" onClick={() => flash('Cancelado', 'warn')}>
          Cancelar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  btnDeleteA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="danger" onClick={() => flash('Excluído', 'err')}>
          Excluir
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnDeleteB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="danger-outline" onClick={() => flash('Excluído', 'err')}>
          Excluir
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  btnDeleteC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn variant="danger-ghost" onClick={() => flash('Excluído', 'err')}>
          🗑 Excluir registro
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  inputLineA: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Nome">
          <DemoInput value={v} onChange={setV} placeholder="Digite aqui…" appearance="bordered" />
        </Field>
      </Box>
    )
  },
  inputLineB: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Nome">
          <DemoInput value={v} onChange={setV} placeholder="Underline…" appearance="underline" />
        </Field>
      </Box>
    )
  },
  inputLineC: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Nome">
          <DemoInput value={v} onChange={setV} placeholder="Fundo preenchido…" appearance="filled" />
        </Field>
      </Box>
    )
  },

  inputAreaA: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Observação">
          <DemoTextarea value={v} onChange={setV} placeholder="Descrição longa…" />
        </Field>
      </Box>
    )
  },
  inputAreaB: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Observação">
          <DemoTextarea value={v} onChange={setV} placeholder="Com contador…" maxLength={120} />
        </Field>
      </Box>
    )
  },
  inputAreaC: () => {
    const [v, setV] = useState('')
    return (
      <Box>
        <Field label="Observação">
          <DemoTextarea value={v} onChange={setV} placeholder="Redimensionável…" appearance="resize" />
        </Field>
      </Box>
    )
  },

  inputMaskA: () => {
    const [cpf, setCpf] = useState('')
    return (
      <Box>
        <Field label="CPF">
          <MaskedInput
            unmask
            mask="000.000.000-00"
            lazy={false}
            value={cpf}
            onAccept={setCpf}
          />
        </Field>
      </Box>
    )
  },
  inputMaskB: () => {
    const [valor, setValor] = useState('')
    return (
      <Box>
        <Field label="Valor">
          <MaskedInput
            unmask
            mask="R$ num"
            blocks={MONEY_BLOCKS}
            lazy={false}
            value={valor}
            onAccept={setValor}
          />
        </Field>
      </Box>
    )
  },
  inputMaskC: () => {
    const [cnpj, setCnpj] = useState('')
    const [tel, setTel] = useState('')
    return (
      <Box>
        <Field label="CNPJ">
          <MaskedInput
            unmask
            mask="00.000.000/0000-00"
            lazy={false}
            value={cnpj}
            onAccept={setCnpj}
          />
        </Field>
        <Field label="Celular">
          <MaskedInput
            unmask
            mask="(00) 00000-0000"
            lazy={false}
            value={tel}
            onAccept={setTel}
          />
        </Field>
      </Box>
    )
  },

  selectA: () => {
    const [v, setV] = useState(STATUS_OPTS[0])
    return (
      <Box>
        <Field label="Status">
          <OikosSelect options={STATUS_OPTS} value={v} onChange={setV} />
        </Field>
      </Box>
    )
  },
  selectB: () => {
    const [v, setV] = useState('aberto')
    return (
      <Box>
        <Field label="Status">
          <DemoSelect value={v} onChange={setV} options={STATUS_OPTS} />
        </Field>
      </Box>
    )
  },
  selectC: () => {
    const [v, setV] = useState('aberto')
    return (
      <Box>
        <Field label="Status">
          <DemoSelect value={v} onChange={setV} options={STATUS_OPTS} searchable />
        </Field>
      </Box>
    )
  },

  selectAsyncA: () => {
    const opts = [
      { value: 'a', label: 'Alpha Ltda' },
      { value: 'b', label: 'Beta Serviços' },
      { value: 'c', label: 'Gama SA' },
    ]
    const [v, setV] = useState('b')
    return (
      <Box>
        <Field label="Fornecedor">
          <DemoSelect value={v} onChange={setV} options={opts} searchable />
        </Field>
      </Box>
    )
  },
  selectAsyncB: () => {
    const opts = [
      { value: 'ms', label: 'Maria Silva' },
      { value: 'jb', label: 'João Bruno' },
    ]
    const [v, setV] = useState('ms')
    return (
      <Box>
        <Field label="Responsável">
          <DemoSelect value={v} onChange={setV} options={opts} searchable />
        </Field>
      </Box>
    )
  },
  selectAsyncC: () => {
    const [opts, setOpts] = useState([
      { value: 'a', label: 'Cliente A' },
      { value: 'b', label: 'Cliente B' },
    ])
    const [v, setV] = useState('a')
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <Field label="Cliente">
          <DemoSelect value={v} onChange={setV} options={opts} searchable />
        </Field>
        <DemoBtn
          variant="outline"
          onClick={() => {
            const id = `n${opts.length + 1}`
            setOpts([...opts, { value: id, label: `Cliente novo ${opts.length + 1}` }])
            setV(id)
            flash('Cliente criado na demo')
          }}
        >
          + Criar novo cliente
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  selectMultiA: () => {
    const options = [
      { value: 'rh', label: 'RH' },
      { value: 'fin', label: 'Financeiro' },
      { value: 'ti', label: 'TI' },
      { value: 'jur', label: 'Jurídico' },
    ]
    const [vals, setVals] = useState([options[0], options[1]])
    return (
      <Box>
        <Field label="Áreas">
          <OikosSelect isMulti options={options} value={vals} onChange={setVals} />
        </Field>
      </Box>
    )
  },
  iconCatalog: () => (
    <Box>
      <ErpIconCatalog />
    </Box>
  ),
  selectMultiB: () => {
    const [sel, setSel] = useState({ ler: true, editar: true, excluir: false })
    return (
      <Box>
        <Field label="Permissões">
          <DemoCheck
            checked={sel.ler}
            label="Ler"
            onChange={(c) => setSel({ ...sel, ler: c })}
          />
          <DemoCheck
            checked={sel.editar}
            label="Editar"
            onChange={(c) => setSel({ ...sel, editar: c })}
          />
          <DemoCheck
            checked={sel.excluir}
            label="Excluir"
            onChange={(c) => setSel({ ...sel, excluir: c })}
          />
        </Field>
      </Box>
    )
  },
  selectMultiC: () => {
    const all = ['urgente', '2026', 'interno', 'cliente', 'revisão']
    const [vals, setVals] = useState(['urgente', '2026'])
    const hidden = all.filter((t) => !vals.includes(t))
    return (
      <Box>
        <Field label="Tags">
          <DemoChips
            values={vals}
            onRemove={(x) => setVals(vals.filter((v) => v !== x))}
            onAdd={
              hidden.length
                ? () => setVals([...vals, hidden[0]])
                : undefined
            }
            addLabel={hidden.length ? `+${hidden.length}` : undefined}
          />
        </Field>
      </Box>
    )
  },

  dateA: () => {
    const [v, setV] = useState('2026-08-24')
    return (
      <Box>
        <Field label="Data">
          <DemoInput type="date" value={v} onChange={setV} />
        </Field>
      </Box>
    )
  },
  dateB: () => {
    const [de, setDe] = useState('2026-08-01')
    const [ate, setAte] = useState('2026-08-31')
    return (
      <Box className="erp-mock-row">
        <Field label="De">
          <DemoInput type="date" value={de} onChange={setDe} />
        </Field>
        <Field label="Até">
          <DemoInput type="date" value={ate} onChange={setAte} />
        </Field>
      </Box>
    )
  },
  dateC: () => {
    const [d, setD] = useState('2026-08-24')
    const [h, setH] = useState('14:30')
    return (
      <Box className="erp-mock-row">
        <Field label="Data">
          <DemoInput type="date" value={d} onChange={setD} />
        </Field>
        <Field label="Hora">
          <DemoInput type="time" value={h} onChange={setH} />
        </Field>
      </Box>
    )
  },

  toggleA: () => {
    const [on, setOn] = useState(true)
    return (
      <Box className="erp-mock-row erp-mock-row--center">
        <DemoSwitch checked={on} onChange={setOn} />
        <span className="small text-muted">{on ? 'Ativo' : 'Inativo'}</span>
      </Box>
    )
  },
  toggleB: () => {
    const [on, setOn] = useState(true)
    return (
      <Box className="erp-mock-row erp-mock-row--center">
        <DemoSwitch checked={on} onChange={setOn} labels={['Não', 'Sim']} />
      </Box>
    )
  },
  toggleC: () => {
    const [on, setOn] = useState(true)
    return (
      <Box>
        <DemoCheck checked={on} onChange={setOn} label={on ? 'Ativo' : 'Inativo'} />
      </Box>
    )
  },

  tableA: () => (
    <Box>
      <OikosListingTable />
    </Box>
  ),
  tableB: () => (
    <Box>
      <OikosListingTable />
    </Box>
  ),
  tableC: () => (
    <Box>
      <OikosListingTable />
    </Box>
  ),

  kpiA: () => (
    <Box className="erp-mock-kpi">
      <span className="erp-mock-kpi__value">128</span>
      <span className="erp-mock-kpi__label">Projetos ativos</span>
    </Box>
  ),
  kpiB: () => (
    <Box className="erp-mock-kpi">
      <span className="erp-mock-kpi__value">R$ 42k</span>
      <span className="erp-mock-kpi__trend is-up">↑ 12% vs mês</span>
      <span className="erp-mock-kpi__label">Receita</span>
    </Box>
  ),
  kpiC: () => {
    const [pct, setPct] = useState(76)
    return (
      <Box className="erp-mock-kpi">
        <span className="erp-mock-kpi__value">{pct}%</span>
        <div className="erp-mock-meter">
          <span style={{ width: `${pct}%` }} />
        </div>
        <input
          type="range"
          min={0}
          max={100}
          value={pct}
          onChange={(e) => setPct(Number(e.target.value))}
          className="erp-demo-range"
        />
        <span className="erp-mock-kpi__label">Meta 100% (arraste)</span>
      </Box>
    )
  },

  cardPanelA: () => (
    <Box className="erp-mock-card-panel">
      <div className="erp-mock-card-panel__head">Resumo do contrato</div>
      <div className="erp-mock-card-panel__body">
        <p className="mb-0 small">Cliente: Acme Ltda · Vigência até 31/12/2026</p>
      </div>
    </Box>
  ),
  cardPanelB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-card-panel">
        <div className="erp-mock-card-panel__head">Pendência #441</div>
        <div className="erp-mock-card-panel__body">
          <p className="mb-0 small">Documento aguardando revisão jurídica.</p>
        </div>
        <div className="erp-mock-card-panel__foot">
          <DemoBtn variant="ghost" onClick={() => flash('Adiado')}>
            Depois
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aberto')}>
            Revisar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  cardPanelC: () => (
    <Box className="erp-mock-card-panel">
      <div className="erp-mock-card-panel__head">
        Orçamento Q3
        <span className="erp-mock-card-panel__tag">Prioritário</span>
      </div>
      <div className="erp-mock-card-panel__body">
        <p className="mb-0 small">Meta: R$ 120k · Realizado: R$ 86k</p>
      </div>
    </Box>
  ),

  filterA: () => (
    <Box>
      <OikosListingTable />
    </Box>
  ),
  filterB: () => {
    const [chips, setChips] = useState(['Status: Aberto', '2026'])
    return (
      <Box>
        <DemoChips
          values={chips}
          onRemove={(x) => setChips(chips.filter((c) => c !== x))}
          onAdd={() => {
            if (!chips.includes('EP: SSA')) setChips([...chips, 'EP: SSA'])
          }}
          addLabel="+ filtro"
        />
      </Box>
    )
  },
  filterC: () => {
    const [status, setStatus] = useState('todos')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-drawer erp-mock-drawer--sm">
        <div className="erp-mock-drawer__bar">Filtros</div>
        <div className="erp-mock-drawer__body">
          <Field label="Status">
            <DemoSelect
              value={status}
              onChange={setStatus}
              options={[
                { value: 'todos', label: 'Todos' },
                ...STATUS_OPTS,
              ]}
            />
          </Field>
          <DemoBtn variant="primary" onClick={() => flash('Filtros aplicados')}>
            Aplicar
          </DemoBtn>
          <Flash message={msg} tone={tone} />
        </div>
      </div>
    )
  },

  formA: () => {
    const [a, setA] = useState('')
    const [b, setB] = useState('')
    const [c, setC] = useState('')
    return (
      <Box>
        <Field label="Campo 1">
          <DemoInput value={a} onChange={setA} />
        </Field>
        <Field label="Campo 2">
          <DemoInput value={b} onChange={setB} />
        </Field>
        <Field label="Campo 3">
          <DemoInput value={c} onChange={setC} />
        </Field>
      </Box>
    )
  },
  formB: () => {
    const [f, setF] = useState({ a: '', b: '', c: '', d: '' })
    return (
      <Box className="erp-mock-form-2">
        {['a', 'b', 'c', 'd'].map((k, i) => (
          <Field key={k} label={i % 2 === 0 ? 'Esquerda' : 'Direita'}>
            <DemoInput value={f[k]} onChange={(v) => setF({ ...f, [k]: v })} />
          </Field>
        ))}
      </Box>
    )
  },
  formC: () => {
    const [nome, setNome] = useState('')
    return (
      <DemoAccordion
        sections={[
          {
            id: 'g',
            title: 'Dados gerais',
            body: (
              <Field label="Nome">
                <DemoInput value={nome} onChange={setNome} placeholder="…" />
              </Field>
            ),
          },
          { id: 'e', title: 'Endereço', body: <span className="text-muted small">Campos de endereço</span> },
          { id: 'c', title: 'Contatos', body: <span className="text-muted small">E-mail e telefone</span> },
        ]}
      />
    )
  },

  tabsA: () => {
    const [tab, setTab] = useState('dados')
    return (
      <Box>
        <OikosTabs
          tabs={[
            { id: 'dados', label: 'Dados' },
            { id: 'contato', label: 'Contato' },
            { id: 'anexos', label: 'Anexos' },
          ]}
          active={tab}
          onChange={setTab}
        >
          <span className="small text-muted">
            {tab === 'dados' && 'Campos de identificação'}
            {tab === 'contato' && 'E-mail e telefone'}
            {tab === 'anexos' && 'Lista de arquivos'}
          </span>
        </OikosTabs>
      </Box>
    )
  },
  tabsB: () => {
    const [tab, setTab] = useState('abertos')
    return (
      <Box>
        <OikosTabs
          tabs={[
            { id: 'abertos', label: 'Abertos (12)' },
            { id: 'analise', label: 'Em análise (3)' },
            { id: 'fechados', label: 'Fechados (48)' },
          ]}
          active={tab}
          onChange={setTab}
        >
          <span className="small text-muted">Painel: {tab}</span>
        </OikosTabs>
      </Box>
    )
  },
  tabsC: () => {
    const [tab, setTab] = useState('legal')
    return (
      <Box>
        <OikosTabs
          tabs={[
            { id: 'legal', label: 'Solicitação Jurídica' },
            { id: 'created', label: 'Ofícios Criados' },
            { id: 'received', label: 'Ofícios Recebidos' },
          ]}
          active={tab}
          onChange={setTab}
        >
          <span className="small text-muted">Seção {tab}</span>
        </OikosTabs>
      </Box>
    )
  },

  accordionA: () => {
    const [nome, setNome] = useState('')
    return (
      <Box>
        <DemoAccordion
          sections={[
            {
              id: 'g',
              title: 'Dados gerais',
              body: (
                <Field label="Nome">
                  <DemoInput value={nome} onChange={setNome} placeholder="…" />
                </Field>
              ),
            },
            { id: 'e', title: 'Endereço', body: <span className="text-muted small">Campos de endereço</span> },
            { id: 'c', title: 'Contatos', body: <span className="text-muted small">E-mail e telefone</span> },
          ]}
        />
      </Box>
    )
  },
  accordionB: () => {
    const [open, setOpen] = useState({ g: true, e: true, c: false })
    const toggle = (id) => setOpen((o) => ({ ...o, [id]: !o[id] }))
    const sections = [
      { id: 'g', title: 'Dados gerais', body: <span className="text-muted small">Nome, CNPJ…</span> },
      { id: 'e', title: 'Endereço', body: <span className="text-muted small">Logradouro, cidade…</span> },
      { id: 'c', title: 'Contatos', body: <span className="text-muted small">E-mail, telefone…</span> },
    ]
    return (
      <Box>
        {sections.map((s, i) => (
          <div key={s.id}>
            <button
              type="button"
              className={`erp-mock-acc erp-demo-acc${open[s.id] ? ' is-open' : ''}`}
              onClick={() => toggle(s.id)}
            >
              {i + 1}. {s.title} {open[s.id] ? '▾' : '▸'}
            </button>
            {open[s.id] && <div className="erp-mock-acc-body">{s.body}</div>}
          </div>
        ))}
      </Box>
    )
  },
  accordionC: () => {
    const [openId, setOpenId] = useState('g')
    const sections = [
      { id: 'g', title: 'Identificação' },
      { id: 'e', title: 'Endereço' },
      { id: 'c', title: 'Anexos' },
    ]
    return (
      <Box>
        {sections.map((s) => {
          const open = openId === s.id
          return (
            <div key={s.id}>
              <button
                type="button"
                className={`erp-mock-acc erp-mock-acc--dense erp-demo-acc${open ? ' is-open' : ''}`}
                onClick={() => setOpenId(open ? null : s.id)}
              >
                {s.title} {open ? '▾' : '▸'}
              </button>
              {open && (
                <div className="erp-mock-acc-body erp-mock-acc-body--dense">
                  <span className="text-muted small">Conteúdo de {s.title.toLowerCase()}</span>
                </div>
              )}
            </div>
          )
        })}
      </Box>
    )
  },

  pageA: () => (
    <Box>
      <h3 className="erp-mock-h3 mb-0">Projetos</h3>
    </Box>
  ),
  pageB: () => (
    <Box className="erp-mock-head">
      <h3 className="erp-mock-h3 mb-0">Projeto Alpha</h3>
      <span className="erp-mock-crumb">Início / Projetos / Alpha</span>
    </Box>
  ),
  pageC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-head erp-mock-head--actions">
        <h3 className="erp-mock-h3 mb-0">Contratos</h3>
        <div>
          <DemoBtn variant="outline" onClick={() => flash('Exportando…')}>
            Exportar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Abrir novo')}>
            Novo
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  navA: () => {
    const [on, setOn] = useState('Projetos')
    return (
      <div className="erp-mock-chrome">
        <div className="erp-mock-chrome__top erp-demo-nav-top">
          {['Dashboard', 'Projetos', 'Financeiro'].map((m) => (
            <button
              key={m}
              type="button"
              className={on === m ? 'is-on' : ''}
              onClick={() => setOn(m)}
            >
              {m}
            </button>
          ))}
        </div>
        <Flash message={`Módulo: ${on}`} />
      </div>
    )
  },
  navB: () => {
    const [on, setOn] = useState('Início')
    return (
      <div className="erp-mock-chrome erp-mock-chrome--side">
        <aside>
          {['Início', 'Projetos', 'Financeiro', 'RH'].map((m) => (
            <button
              key={m}
              type="button"
              className={on === m ? 'is-on' : ''}
              onClick={() => setOn(m)}
            >
              {m}
            </button>
          ))}
        </aside>
        <main>{on}</main>
      </div>
    )
  },
  navC: () => {
    const [tab, setTab] = useState('geral')
    return (
      <Box>
        <div className="erp-mock-chrome__top erp-mock-chrome__top--sm">Oikos · Projetos</div>
        <DemoTabs
          tabs={[
            { id: 'geral', label: 'Geral' },
            { id: 'equipe', label: 'Equipe' },
            { id: 'fin', label: 'Financeiro' },
          ]}
          active={tab}
          onChange={setTab}
        >
          Conteúdo: {tab}
        </DemoTabs>
      </Box>
    )
  },

  modalConfirmA: () => {
    const [open, setOpen] = useState(true)
    const { msg, tone, flash } = useFlash()
    if (!open) {
      return (
        <Box>
          <DemoBtn variant="outline" onClick={() => setOpen(true)}>
            Abrir modal
          </DemoBtn>
          <Flash message={msg} tone={tone} />
        </Box>
      )
    }
    return (
      <div className="erp-mock-modal">
        <div className="erp-mock-modal__bar">
          <strong>Confirmar?</strong>
          <button type="button" className="erp-demo-x" onClick={() => setOpen(false)}>
            ×
          </button>
        </div>
        <div className="erp-mock-modal__body">Deseja continuar com esta ação?</div>
        <div className="erp-mock-modal__foot">
          <DemoBtn
            variant="outline"
            onClick={() => {
              setOpen(false)
              flash('Cancelado', 'warn')
            }}
          >
            Não
          </DemoBtn>
          <DemoBtn
            variant="primary"
            onClick={() => {
              setOpen(false)
              flash('Confirmado ✓')
            }}
          >
            Sim
          </DemoBtn>
        </div>
      </div>
    )
  },
  modalConfirmB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal">
        <div className="erp-mock-modal__body erp-mock-modal__body--center">
          <div className="erp-mock-alert-icon">⚠</div>
          <strong>Atenção</strong>
          <p>Esta ação precisa da sua confirmação.</p>
        </div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Continuar ✓')}>
            Continuar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  modalConfirmC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal">
        <div className="erp-mock-modal__bar">
          <strong>Excluir registro?</strong>
        </div>
        <div className="erp-mock-modal__body">Não será possível desfazer.</div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => flash('Mantido')}>
            Manter
          </DemoBtn>
          <DemoBtn variant="danger" onClick={() => flash('Excluído', 'err')}>
            Excluir
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },

  modalFormA: () => {
    const [nome, setNome] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal erp-mock-modal--sm">
        <div className="erp-mock-modal__bar">
          <strong>Novo</strong>
        </div>
        <div className="erp-mock-modal__body">
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
        </div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => setNome('')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash(`Salvo: ${nome || '(vazio)'}`)}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  modalFormB: () => {
    const [nome, setNome] = useState('')
    const [tipo, setTipo] = useState('a')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal">
        <div className="erp-mock-modal__bar">
          <strong>Novo registro</strong>
        </div>
        <div className="erp-mock-modal__body">
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
          <Field label="Tipo">
            <DemoSelect
              value={tipo}
              onChange={setTipo}
              options={[
                { value: 'a', label: 'Tipo A' },
                { value: 'b', label: 'Tipo B' },
              ]}
            />
          </Field>
        </div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  modalFormC: () => {
    const [tab, setTab] = useState('dados')
    const [nome, setNome] = useState('')
    return (
      <div className="erp-mock-modal erp-mock-modal--wide">
        <div className="erp-mock-modal__bar">
          <strong>Cadastro</strong>
        </div>
        <DemoTabs
          tabs={[
            { id: 'dados', label: 'Dados' },
            { id: 'contato', label: 'Contato' },
            { id: 'anexos', label: 'Anexos' },
          ]}
          active={tab}
          onChange={setTab}
        >
          {tab === 'dados' && (
            <Field label="Razão social">
              <DemoInput value={nome} onChange={setNome} />
            </Field>
          )}
          {tab === 'contato' && <span className="small text-muted">E-mail e telefone</span>}
          {tab === 'anexos' && <span className="small text-muted">Lista de arquivos</span>}
        </DemoTabs>
      </div>
    )
  },

  drawerA: () => (
    <div className="erp-mock-drawer">
      <div className="erp-mock-drawer__bar">Detalhe</div>
      <div className="erp-mock-drawer__body">
        <p className="erp-mock-dl">
          <span>Nome</span>
          <strong>Registro X</strong>
        </p>
        <p className="erp-mock-dl">
          <span>Status</span>
          <strong>Ativo</strong>
        </p>
      </div>
    </div>
  ),
  drawerB: () => {
    const [nome, setNome] = useState('Registro X')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-drawer">
        <div className="erp-mock-drawer__bar">Editar</div>
        <div className="erp-mock-drawer__body">
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
          <DemoBtn variant="primary" onClick={() => flash(`Salvo: ${nome}`)}>
            Salvar
          </DemoBtn>
          <Flash message={msg} tone={tone} />
        </div>
      </div>
    )
  },
  drawerC: () => {
    const [status, setStatus] = useState('todos')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-drawer">
        <div className="erp-mock-drawer__bar">Filtros</div>
        <div className="erp-mock-drawer__body">
          <Field label="Status">
            <DemoSelect
              value={status}
              onChange={setStatus}
              options={[{ value: 'todos', label: 'Todos' }, ...STATUS_OPTS]}
            />
          </Field>
          <DemoBtn variant="primary" onClick={() => flash('Aplicado')}>
            Aplicar
          </DemoBtn>
          <Flash message={msg} tone={tone} />
        </div>
      </div>
    )
  },

  loadingA: () => (
    <Box className="erp-mock-loading">
      <span className="erp-mock-spinner" aria-hidden />
      <span className="small text-muted">Carregando…</span>
    </Box>
  ),
  loadingB: () => (
    <Box>
      <div className="erp-mock-skel-row" />
      <div className="erp-mock-skel-row" style={{ width: '85%' }} />
      <div className="erp-mock-skel-row" style={{ width: '70%' }} />
      <div className="erp-mock-skel-row" style={{ width: '92%' }} />
    </Box>
  ),
  loadingC: () => (
    <Box className="erp-mock-row erp-mock-row--center">
      <DemoBtn variant="primary" disabled>
        <span className="erp-mock-spinner erp-mock-spinner--sm" aria-hidden /> Salvando…
      </DemoBtn>
      <span className="erp-mock-input-loading">
        <DemoInput value="" onChange={() => {}} placeholder="Buscando…" />
        <span className="erp-mock-spinner erp-mock-spinner--sm" aria-hidden />
      </span>
    </Box>
  ),

  alertBannerA: () => (
    <Box>
      <div className="erp-mock-alert is-err" role="alert">
        Não foi possível salvar. Verifique os campos obrigatórios.
      </div>
    </Box>
  ),
  alertBannerB: () => (
    <Box>
      <div className="erp-mock-alert is-warn" role="status">
        Há alterações não salvas nesta página.
      </div>
    </Box>
  ),
  alertBannerC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <div className="erp-mock-alert is-info" role="status">
          <span>Atualização disponível para este módulo.</span>
          <DemoBtn variant="ghost" onClick={() => flash('Detalhes…')}>
            Ver detalhes
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  toastA: () => {
    const [list, setList] = useState([])
    const push = (text, kind) => {
      const id = Date.now()
      setList((l) => [...l, { id, text, kind }])
      setTimeout(() => setList((l) => l.filter((x) => x.id !== id)), 2000)
    }
    return (
      <Box>
        <div className="erp-mock-row">
          <DemoBtn variant="primary" onClick={() => push('✓ Salvo com sucesso', 'ok')}>
            Sucesso
          </DemoBtn>
          <DemoBtn variant="danger" onClick={() => push('✕ Falha ao salvar', 'err')}>
            Erro
          </DemoBtn>
        </div>
        <div className="erp-mock-toast-stack">
          {list.map((t) => (
            <div key={t.id} className={`erp-mock-toast is-${t.kind}`}>
              {t.text}
            </div>
          ))}
        </div>
      </Box>
    )
  },
  toastB: () => {
    const [show, setShow] = useState(false)
    return (
      <Box>
        <DemoBtn variant="primary" onClick={() => setShow(true)}>
          Mostrar barra
        </DemoBtn>
        {show && (
          <div className="erp-mock-toast is-ok erp-mock-toast-stack--bar" style={{ marginTop: 8 }}>
            Salvo com sucesso{' '}
            <button type="button" className="erp-demo-x" onClick={() => setShow(false)}>
              ×
            </button>
          </div>
        )}
      </Box>
    )
  },
  toastC: () => {
    const [nome, setNome] = useState('')
    const [ok, setOk] = useState(false)
    return (
      <Box>
        <Field label="Nome">
          <DemoInput value={nome} onChange={setNome} />
        </Field>
        <DemoBtn
          variant="primary"
          onClick={() => {
            setOk(true)
            setTimeout(() => setOk(false), 2000)
          }}
        >
          Salvar
        </DemoBtn>
        {ok && <div className="erp-mock-toast is-ok erp-mock-toast--inline">✓ Alterações salvas</div>}
      </Box>
    )
  },

  emptyA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-empty">
        <strong>Nenhum registro</strong>
        <span>Comece criando o primeiro item.</span>
        <DemoBtn variant="primary" onClick={() => flash('Criar…')}>
          Criar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  emptyB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-empty">
        <div className="erp-mock-empty-illu" aria-hidden />
        <strong>Nada por aqui</strong>
        <DemoBtn variant="primary" onClick={() => flash('Novo…')}>
          Novo
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  emptyC: () => (
    <Box className="erp-mock-empty erp-mock-empty--quiet">
      <span className="text-muted">Nenhum resultado para esta busca.</span>
    </Box>
  ),

  badgeA: () => {
    const [s, setS] = useState('aprovado')
    return (
      <Box className="erp-mock-row">
        {[
          ['aprovado', 'Aprovado', 'ok'],
          ['pendente', 'Pendente', 'warn'],
          ['recusado', 'Recusado', 'err'],
        ].map(([id, label, cls]) => (
          <button
            key={id}
            type="button"
            className={`erp-mock-pill is-${cls}${s === id ? ' erp-demo-pill-on' : ''}`}
            onClick={() => setS(id)}
          >
            {label}
          </button>
        ))}
      </Box>
    )
  },
  badgeB: () => {
    const [s, setS] = useState('aprovado')
    return (
      <Box className="erp-mock-row">
        {[
          ['aprovado', 'Aprovado', 'ok'],
          ['pendente', 'Pendente', 'warn'],
          ['recusado', 'Recusado', 'err'],
        ].map(([id, label, cls]) => (
          <button
            key={id}
            type="button"
            className={`erp-mock-dotlabel erp-demo-chip${s === id ? ' erp-demo-pill-on' : ''}`}
            onClick={() => setS(id)}
          >
            <i className={`is-${cls}`} /> {label}
          </button>
        ))}
      </Box>
    )
  },
  badgeC: () => {
    const [s, setS] = useState('aprovado')
    return (
      <Box className="erp-mock-row">
        {[
          ['aprovado', 'Aprovado', 'ok'],
          ['pendente', 'Pendente', 'warn'],
          ['recusado', 'Recusado', 'err'],
        ].map(([id, label, cls]) => (
          <button
            key={id}
            type="button"
            className={`erp-mock-pill erp-mock-pill--outline is-${cls}${
              s === id ? ' erp-demo-pill-on' : ''
            }`}
            onClick={() => setS(id)}
          >
            {label}
          </button>
        ))}
      </Box>
    )
  },

  stepA: () => {
    const [cur, setCur] = useState(2)
    const steps = [0, 1, 2, 3]
    return (
      <Box>
        <div className="erp-mock-steps erp-demo-steps">
          {steps.map((i, idx) => (
            <React.Fragment key={i}>
              <button
                type="button"
                className={i < cur ? 'is-done' : i === cur ? 'is-now' : ''}
                onClick={() => setCur(i)}
              />
              {idx < steps.length - 1 && <i />}
            </React.Fragment>
          ))}
        </div>
        <div className="erp-mock-step-labels">
          <span>Aberto</span>
          <span>Análise</span>
          <span>Aprovação</span>
          <span>Fim</span>
        </div>
      </Box>
    )
  },
  stepB: () => {
    const [cur, setCur] = useState(1)
    return (
      <Box>
        <div className="erp-mock-steps erp-mock-steps--num erp-demo-steps">
          {[1, 2, 3].map((n, idx) => (
            <React.Fragment key={n}>
              <button
                type="button"
                className={n - 1 < cur ? 'is-done' : n - 1 === cur ? 'is-now' : ''}
                onClick={() => setCur(n - 1)}
              >
                {n}
              </button>
              {idx < 2 && <i />}
            </React.Fragment>
          ))}
        </div>
        <div className="erp-mock-step-labels">
          <span>Elaboração</span>
          <span>Revisão</span>
          <span>Fim</span>
        </div>
      </Box>
    )
  },
  stepC: () => {
    const items = [
      { id: 'a', t: 'Criado', d: '01/08' },
      { id: 'b', t: 'Enviado', d: '03/08' },
      { id: 'c', t: 'Em revisão', d: 'hoje' },
    ]
    const [now, setNow] = useState('c')
    return (
      <Box>
        <ul className="erp-mock-timeline">
          {items.map((it) => (
            <li key={it.id} className={now === it.id ? 'is-now' : ''}>
              <button type="button" className="erp-demo-tl-btn" onClick={() => setNow(it.id)}>
                <strong>{it.t}</strong>
                <span>{it.d}</span>
              </button>
            </li>
          ))}
        </ul>
      </Box>
    )
  },

  uploadA: () => {
    const [files, setFiles] = useState([])
    return (
      <Box>
        <p className="small text-muted">Componente atual: CompactAddFiles.</p>
        <CompactAddFiles files={files} onFilesChange={setFiles} />
      </Box>
    )
  },
  uploadB: () => {
    const [files, setFiles] = useState([])
    const [over, setOver] = useState(false)
    return (
      <Box>
        <div
          className={`erp-mock-drop${over ? ' erp-demo-drop-on' : ''}`}
          onDragOver={(e) => {
            e.preventDefault()
            setOver(true)
          }}
          onDragLeave={() => setOver(false)}
          onDrop={(e) => {
            e.preventDefault()
            setOver(false)
            const names = [...e.dataTransfer.files].map((f) => f.name)
            if (names.length) setFiles([...files, ...names])
            else setFiles([...files, 'arquivo-demo.pdf'])
          }}
          onClick={() => setFiles([...files, `drop-${files.length + 1}.pdf`])}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setFiles([...files, 'arquivo.pdf'])}
        >
          Arraste arquivos aqui ou clique
        </div>
        <ul className="erp-mock-filelist">
          {files.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>
      </Box>
    )
  },
  uploadC: () => {
    const [items, setItems] = useState(['PDF', 'IMG'])
    return (
      <Box className="erp-mock-thumbs">
        {items.map((t, i) => (
          <button
            key={`${t}-${i}`}
            type="button"
            title="Remover"
            onClick={() => setItems(items.filter((_, j) => j !== i))}
          >
            {t}
          </button>
        ))}
        <button type="button" onClick={() => setItems([...items, 'NEW'])}>
          +
        </button>
      </Box>
    )
  },

  chartA: () => (
    <Box>
      <p className="small text-muted mb-0">
        Barras, linha e pizza continuam na ferramenta do Gustavo. Desmontar esse HTML para usar o gráfico em outras telas fica para outra hora.
      </p>
    </Box>
  ),
  chartB: () => (
    <Box>
      <p className="small text-muted mb-0">
        Linha: mesmo arquivo, ainda sem componente solto para encaixar na tela.
      </p>
    </Box>
  ),
  chartC: () => (
    <Box>
      <p className="small text-muted mb-0">
        Pizza: mesmo arquivo, ainda sem componente solto para encaixar na tela.
      </p>
    </Box>
  ),

  approvalA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard erp-mock-apcard--row">
        <div>
          <strong>Pedido #881</strong>
          <p>Compra — R$ 4.200</p>
        </div>
        <div>
          <DemoBtn variant="danger-outline" onClick={() => flash('Rejeitado', 'err')}>
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  approvalB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard">
        <strong>Pedido #881</strong>
        <p>Compra de equipamentos — R$ 4.200</p>
        <div className="erp-mock-apcard__full">
          <DemoBtn variant="danger" onClick={() => flash('Rejeitado', 'err')}>
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  approvalC: () => {
    const [motivo, setMotivo] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard">
        <strong>Pedido #881</strong>
        <p>Compra — R$ 4.200</p>
        <Field label="Motivo (se rejeitar)">
          <DemoTextarea value={motivo} onChange={setMotivo} />
        </Field>
        <div>
          <DemoBtn
            variant="danger-outline"
            onClick={() =>
              flash(motivo ? `Rejeitado: ${motivo}` : 'Informe o motivo', motivo ? 'err' : 'warn')
            }
          >
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  moneyA: () => (
    <Box className="erp-mock-kpi">
      <span className="erp-mock-kpi__value">R$ 12.450,00</span>
      <span className="erp-mock-kpi__label">Saldo disponível</span>
    </Box>
  ),
  moneyB: () => (
    <Box>
      <table className="erp-mock-table">
        <tbody>
          <tr>
            <td>Pessoal</td>
            <td className="text-right">R$ 8.000</td>
          </tr>
          <tr>
            <td>Material</td>
            <td className="text-right">R$ 3.200</td>
          </tr>
          <tr>
            <td>Outros</td>
            <td className="text-right">R$ 1.250</td>
          </tr>
          <tr>
            <th>Total</th>
            <th className="text-right">R$ 12.450</th>
          </tr>
        </tbody>
      </table>
    </Box>
  ),
  moneyC: () => (
    <Box>
      <table className="erp-mock-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Histórico</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01/08</td>
            <td>Entrada</td>
            <td className="text-success">+ 5.000</td>
          </tr>
          <tr>
            <td>05/08</td>
            <td>Pagamento</td>
            <td className="text-danger">− 1.200</td>
          </tr>
        </tbody>
      </table>
    </Box>
  ),
}

export default function VariantMock({ mockId }) {
  const Comp = MOCKS[mockId]
  if (!Comp) {
    return <div className="erp-mock-box text-muted small">Mock não definido: {mockId}</div>
  }
  return <Comp />
}
